module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7V1vT"))).then(() => parcelRequire('d0iPb'));